export const pipelineConstants = {
    LAUNCH_PIPELINE_REQUEST: 'LAUNCH_PIPELINE_REQUEST',
    LAUNCH_PIPELINE_SUCCESS: 'LAUNCH_PIPELINE_SUCCESS',
    LAUNCH_PIPELINE_FAILURE: 'LAUNCH_PIPELINE_FAILURE',
};



// WEBPACK FOOTER //
// ./src/_constants/pipeline.js